import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgUser} from "~/assets/svg/user.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmUserIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgUser id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
